module.exports = __webpack_public_path__ + "images/luxe-4-d27888fe280c4d901ef328a64cf07dad.jpg";